<div class="input-wrapper">
  <mat-form-field appearance="outline" class="autocomplete appeal-input">
    <mat-label> {{ placeholder }} {{ required ? '*' : '' }} </mat-label>
    <input
      #inputAutoComplete
      matInput
      type="text"
      [attr.aria-label]="placeholder"
      [matAutocomplete]="autoComplete"
      [formControl]="searchPhrase"
      [errorStateMatcher]="errorMatcher"
    />
  </mat-form-field>

  <svg
    (click)="!isOpen ? openPanel($event) : closePanel()"
    [icon]="isOpen ? icons.ArrowDropUp : icons.ArrowDropDown"
    class="svg24 inactive-color arrow"
  />

  <button class="btn-empty close center" *ngIf="value" (click)="clearValue()">
    <svg [icon]="icons.Close" class="svg18 white-color" />
  </button>
</div>
<mat-autocomplete #autoComplete="matAutocomplete" (opened)="isOpen = true" (closed)="isOpen = false">
  <mat-option *ngIf="loading">
    <app-loader></app-loader>
  </mat-option>
  <ng-container *ngLet="$any(filteredOptions) | async as options">
    <ng-container *ngIf="options?.length < 200">
      <mat-option *ngFor="let option of options" [value]="option.value" (mousedown)="chooseOption(option.value, option.title)" (click)="chooseOption(option.value, option.title)"
        >{{ option.title }}
      </mat-option>
    </ng-container>

    <ng-container *ngIf="options?.length > 200">
      <cdk-virtual-scroll-viewport
        [itemSize]="optionHeight"
        [style.height.px]="options.length > 4 ? maxDropdownHeight : options.length * optionHeight"
      >
        <mat-option *cdkVirtualFor="let option of options" [value]="option.value" (click)="chooseOption(option.value, option.title)"
          >{{ option.title }}
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  </ng-container>
</mat-autocomplete>
